'use client';

import { Tabs } from './components/Tabs';
import { CompanyPageImages, CompanyVideo } from '../../markupConfig';

import { MainContainer } from '@/shared/components/mainContainer';

interface DetailingSectionProps {
  pageTranslations: Record<string, string>;
  images: CompanyPageImages;
  beautifulMapsVideo: CompanyVideo;
}

export const DetailingSection: React.FC<DetailingSectionProps> = ({
  pageTranslations,
  images,
  beautifulMapsVideo,
}) => {
  return (
    <section className="mt-16 lg:mt-[112px]">
      <MainContainer>
        <h2 className="mb-12 text-center text-3xl font-medium lg:text-4xl">
          {pageTranslations.detalizationMapSectionHeader}
        </h2>
        <Tabs
          pageTranslations={pageTranslations}
          images={images}
          beautifulMapsVideo={beautifulMapsVideo}
        />
      </MainContainer>
    </section>
  );
};
